<template lang='pug'>
#cancell-root.cancell-root(:class='[`${specialBgColor}`, { screenMask: topBarSearchBarStatus || topBarNotifyStatus || topBarFeatureStatus || topBarPanelStatus }, { mobileDevice: mobileDevice }]')
  //- .cancell-root(:class='[{ screenMask: topBarHamburgerStatus }, { screenMask: topBarSearchBarStatus }, { screenMask: topBarNotifyStatus }, { screenMask: topBarFeatureStatus }, { screenMask: topBarPanelStatus }]')

  //- 回置頂按鈕
  //- transition(name='ani-slide-up-fade')
  //-   GoTop(v-show='showGoTop')
  //- Cookie(:sessionAllowCookie='loginAgreeCookie')

  //- PopBox區塊
  //- PopBox(v-if='popBoxStatus.active || popProgressStatus.active || popDeleteResumeStatus.active || popYoutubeStatus.active || popCourseStatus.active || popZoomStatus.active || popQRcodeStatus.active || popDrugStatus.active || popAgreeListStatus.active || popBlessStatus.active || popQuestionStatus.active || popDeleteBlessStatus.active || popDeleteReplyStatus.active || popDeleteAskStatus.active || popDeleteTranslationStatus.active || popReportStatus.active || popTeamFeatureStatus.active || popHelpFilterStatus.active || popShowTutorial.active || popFreeTrailStatus.active || popAdviseStatus.active || popTranslatorStatus.active || popAnalysisStatus.active || popLatestNewsStatus.active || popVendorProfile.active')
  PopBox(v-if='hasActivePopBox')

  //- FB Messenger
  //- #fb-root

  //- 上方選單列
  TopBar(:initLoginSessionDone='sessionCheckDone')
  //- 主內容區
  .cancell-wrapper
    EducationBar(v-if='rwdType !== "desktop" && showEducationBar')
    .cc-wrapper-container(:class='showShortCutBar ? "shortcut-padding-space" : ""')
      router-view(v-if='sessionCheckDone' :key='routerPathChange')
    Shortcut(v-if='rwdType !== "desktop" && loginStatus && showShortCutBar')

    //- Footer(v-if='!hideFooter')

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import * as jwt_decode from 'jwt-decode';
import qs from 'qs';
import axios from 'axios';

// import { register } from 'register-service-worker';

import TopBar from './page/topbar/TopBar';
import Footer from './page/common/Footer';
import PopBox from './page/popbox/PopBox';
import Shortcut from './page/Shortcut';
import EducationBar from './page/EducationBar';
// import GoTop from './page/common/GoTop';
// import Cookie from './page/common/Cookie';
import GlobalEmitter from 'tiny-emitter/instance';

// import { Capacitor } from '@capacitor/core';
// import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
// import { SafeArea } from "capacitor-plugin-safe-area";

import {
  getSessionKeepLogin,
  // postUniqueDoctor,
  // postUniqueNormal,
  postUserAutoLogin,
  postJwtToken,
  // putCheckUserSubscribe,
  deleteSessionKeepLogin,
  putLineKeepLogin,
  putUserLoadNews,
  // postWpSaveSubscribe,
} from '../js/restapi';

export default {
  components: {
    TopBar,
    Footer,
    PopBox,
    Shortcut,
    EducationBar,
    // GoTop,
    // Cookie,
  },

  data() {
    return {
      // userDevice: navigator.userAgent,
      // mobileDevice: false,
      specialBgColor: '',
      showEducationBar: false,
      showShortCutBar: true,
      // hideFooter: false,
      clientWidth: 0,
      clientHeight: 0,
      // scrollTop: 0,
      // showGoTop: false,
      sessionCheckDone: false,
      djangoId: null,
      // loginAgreeCookie: false,

      jwtLifeSpan: {
        exp: 604800,
        iat: 1814400,
      },

      wsRoom: null,
      reconnectInterval: 5000, // 重新連線間隔時間（毫秒）
      reconnectAttempts: 0, // 重新連線嘗試次數
      maxReconnectAttempts: 10, // 最大重新連線嘗試次數
      globalEmitterRegistered: false, // 避免重複註冊
    };
  },

  // mixins: [],

  // beforeCreate() {
  //   this.$OneSignal.init({
  //     appId: 'fab7d6fe-205f-4dab-b6de-9c56b2b8e2b7',
  //   });
  // },

  created() {
    // SafeArea.getSafeAreaInsets().then((data) => {
    //   const { insets } = data;
    //   document.body.style.setProperty('--ion-safe-area-top', `${insets.top}px`);
    //   document.body.style.setProperty('--ion-safe-area-right', `${insets.right}px`);
    //   document.body.style.setProperty('--ion-safe-area-bottom', `${insets.bottom}px`);
    //   document.body.style.setProperty('--ion-safe-area-left', `${insets.left}px`);
    // });
    this.$router.onReady(() => {
      // 判斷是否在原生手機環境中運行
      // if (Capacitor.isNativePlatform()) {
      //   StatusBar.setOverlaysWebView({ overlay: true });
      //   StatusBar.setBackgroundColor({ color: '#ffffff' });
      // }
      this.detectUserAgentDevice();
      this.checkSessionOnMounted();
      this.detectEmitterForceMainRefresh();
    });
  },

  mounted() {
    SplashScreen.hide();
    window.addEventListener('resize', this.clientWidthResize);
    // window.addEventListener('scroll', this.handleGoTopBtnShow);
    this.$nextTick(() => {
      this.clientWidthResize();
    });
  },

  beforeDestroy() {
    this.closeWebSocket();
    // window.removeEventListener('scroll', this.handleGoTopBtnShow);
    window.removeEventListener('resize', this.clientWidthResize);
    window.removeEventListener('beforeunload', () => {
      if (this.wsRoom) {
        this.closeWebSocket();
      }
    });
    this.removeEmitterForceMainRefresh();
  },

  methods: {
    ...mapActions({
      userLoginMember: 'user/userLoginMember',
      // changeHamburgerFocus: 'user/changeTopBarHamburgerFocus',
    }),

    ...mapMutations({
      setRwdType: 'global/RWD_TYPE',
      setFlowBarFixed: 'global/FLOW_BAR_FIXED',
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeTeamFeatureStatus: 'global/POPTEAM_FEATURE_STATUS',
      changeHelpFilterStatus: 'global/POPTEAM_FEATURE_STATUS',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopLatestNewsStatus: 'global/POPLATEST_NEWS_STATUS',
      changePopFreeTrailStatus: 'global/POPFREETRAIL_STATUS',
      changeUpdateKey: 'global/FORCE_UPDATE_KEY',
      changeUserSubscribe: 'user/USER_CHECK_SUBSCRIBE',
      changeAuthJwtToken: 'user/USER_AUTH_JWT',

      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
      changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
      changePopChronicBloodDetail: 'global/POPCHRONIC_BLOOD_DETAIL',
      changePopTranslatorStatus: 'global/POPTRANSLATOR_STATUS',
      changePopDietRecognizeStatus: 'global/POPDIET_RECOGNIZE_STATUS',

      updateExclusiveWebSocket: 'user/EXCLUSIVE_WEBSOCKET',
    }),

    // handleGoTopBtnShow() {
    //   this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    //   // console.log('ScrollTop: ', this.scrollTop);
    //   if (this.scrollTop > this.clientHeight * 2) {
    //     this.showGoTop = true;
    //   } else {
    //     this.showGoTop = false;
    //   }
    // },

    detectEmitterForceMainRefresh() {
      if (this.globalEmitterRegistered) return;
      GlobalEmitter.on('force-root-update', this.onForceRootUpdate);
      this.globalEmitterRegistered = true;
    },
    removeEmitterForceMainRefresh() {
      if (!this.globalEmitterRegistered) return;
      GlobalEmitter.off('force-root-update', this.onForceRootUpdate);
      this.globalEmitterRegistered = false;
    },
    onForceRootUpdate(arg) {
      this.checkSessionOnMounted();
      // this.$forceUpdate();
    },

    clientWidthResize() {
      this.clientWidth = document.documentElement.clientWidth;
      this.clientHeight = document.documentElement.clientHeight;
      // INIT Rwd Type
      if (this.clientWidth >= 1280) {
        this.setRwdType('desktop');
        // this.changeHamburgerFocus(false);
      } else if (this.clientWidth < 1280 && this.clientWidth > 1080) {
        this.setRwdType('tablet');
        // this.changeHamburgerFocus(false);
      } else if (this.clientWidth <= 1080 && this.clientWidth > 730) {
        this.setRwdType('tablet-m');
      } else {
        this.setRwdType('mobile');
      }

      if (this.clientWidth > 800) {
        this.changeTeamFeatureStatus({
          active: false,
          features: null,
        });
      }

      if (this.clientWidth > 900) {
        this.changeHelpFilterStatus({
          active: false,
          query: null,
        });
      }
    },

    checkSessionOnMounted() {
      getSessionKeepLogin('')
        .then((response) => {
          const sessionResponse = response.data;
          console.log('檢查保持登入狀態: ', sessionResponse);

          if (sessionResponse.status === 'failed' || !this.authJwtToken) {
            this.sessionCheckDone = true;
            const getJwtItem = localStorage.getItem('cc-jwt');
            console.log('sessionResponse: failed', getJwtItem, this.sessionCheckDone);

            if (getJwtItem) {
              localStorage.removeItem('cc-jwt');
            }
          } else if (sessionResponse.status === 'success' && this.authJwtToken) {
            console.log('sessionResponse: pass');
            this.autoLoginAuthProcess(sessionResponse);
          }

          console.log('JWT Token:', this.authJwtToken);
          console.log('Local Storage JWT:', localStorage.getItem('cc-jwt'));
        })
        .catch((err) => {
          this.sessionCheckDone = true;
          const getJwtItem = localStorage.getItem('cc-jwt');
          console.log('sessionResponse: failed', getJwtItem, this.sessionCheckDone);

          if (getJwtItem) {
            localStorage.removeItem('cc-jwt');
          }
        });
    },

    createJwtUserToken(sessionValue) {
      const POST_DATA = {
        username: sessionValue.account,
        password: sessionValue.password,
      };

      // (登入 Auth Step-2) 使用者登入
      postJwtToken('token2/', qs.stringify(POST_DATA), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(create)，Pass!');

          const loginProcess = new Promise((resolve) => {
            const newJwt = JSON.stringify({
              a: response.data.access,
              r: response.data.refresh,
            });
            const decoded = jwt_decode(response.data.access);
            this.changeAuthJwtToken(newJwt);
            return resolve({
              hashcode: decoded.hashcode,
              jwt: newJwt
            });
          });

          loginProcess.then((obj) => {
            this.userSwitchToLogined(obj.hashcode);
            localStorage.setItem('cc-jwt', obj.jwt);
          });
        })
        .catch((error) => {
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(Access)，Failed!', error.response);
        });
    },

    refreshJwtUserToken() {
      const refreshToken = JSON.parse(this.authJwtToken).r;
      const POST_DATA = {
        refresh: refreshToken,
      };
      // (登入 Auth Step-2) 使用者登入
      postJwtToken('token2/refresh/', qs.stringify(POST_DATA), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(refresh)，Pass!');
          const autoLoginProcess = new Promise((resolve) => {
            const newJwt = JSON.stringify({
              a: response.data.access,
              r: refreshToken,
            });
            const decoded = jwt_decode(response.data.access);
            this.changeAuthJwtToken(newJwt);
            return resolve({
              hashcode: decoded.hashcode,
              jwt: newJwt
            });
          });

          autoLoginProcess.then((obj) => {
            this.userSwitchToLogined(obj.hashcode);
            localStorage.setItem('cc-jwt', obj.jwt);
          });
        })
        .catch((error) => {
          console.log('登入 Auth Step-2:: 驗證帳號並獲取JWT-Token(refresh)，Failed!', error.response);
        });
    },

    autoLoginAuthProcess(sessionResponse) {
      this.djangoId = sessionResponse.auth_id;

      if (sessionResponse.account_login === 'line') {
        this.lineOauthLoginFlow(sessionResponse);
      } else {
        this.cancellOauthLoginFlow(sessionResponse);
      }
    },

    lineOauthLoginFlow(sessionResponse) {
      const hasToken = this.authJwtToken;

      if (hasToken) {
        console.log('Line Login hasToken');
        const accessToken = JSON.parse(hasToken).a;

        const LOGIN_PROFILE = {
          account: sessionResponse.account_login,
          access_token: accessToken,
          lineid: sessionResponse.account,
        };

        putLineKeepLogin('', LOGIN_PROFILE)
          .then((res) => {
            const userProfile = res.data.results;
            const userHashCode = res.data.hashcode;
            if (userProfile.thumbSrc === null) {
              userProfile.thumbSrc = '';
            }

            this.changeUserSubscribe(userProfile.subscribe);
            this.processAfterLogined(userProfile, userHashCode);

            // putCheckUserSubscribe('', {})
            //   .then((res) => {
            //     this.changeUserSubscribe(res.data.subscribe);
            //     this.processAfterLogined(userProfile, userHashCode);
            //   })
            //   .catch((err) => {
            //     console.log('putCheckUserSubscribe 錯誤', err);
            //   });
          })
          .catch((err) => {
            console.log('Line自動登入錯誤', err);
          });
      } else {
        console.log('Line 找不到JWT Token');
      }
    },

    cancellOauthLoginFlow(sessionResponse) {
      const hasToken = this.authJwtToken;
      const TIME_TOLERANCE = 300; // 5分鐘的容錯時間

      if (hasToken) {
        const accessToken = JSON.parse(hasToken).a;
        const decoded = jwt_decode(accessToken);
        const { exp } = decoded;
        const iat = Number(decoded.iat);
        const dateNow = Date.now() / 1000;

        // 添加時間差檢查
        const timeDiff = Math.abs(dateNow - iat);
        if (timeDiff > TIME_TOLERANCE) {
          console.warn('系統時間可能不同步，時間差：', timeDiff, '秒');
        }

        // 修改判斷邏輯，加入容錯時間
        if (exp - dateNow < this.jwtLifeSpan.exp && dateNow - iat < this.jwtLifeSpan.iat + TIME_TOLERANCE && exp - dateNow > 0) {
          console.log('JWT令牌在時效內且超過免驗證時間，JWT做Refresh');
          this.refreshJwtUserToken(sessionResponse.type);
        } else if (exp - dateNow < this.jwtLifeSpan.exp && exp - dateNow > 0) {
          console.log('JWT令牌在免驗證時間內，不做任何事');
          this.userSwitchToLogined(decoded.hashcode);
        } else {
          console.log('JWT令牌過期了，強制登出');
          this.changePopBoxStatus({
            active: true,
            include: 'relogin',
          });

          deleteSessionKeepLogin(`/${decoded.hashcode}`)
            .then((/* response */) => {
              localStorage.removeItem('cc-jwt');
              this.changeAuthJwtToken(null);
              this.userLoginMember({
                isLogin: false,
                djangoId: null,
                hashCode: '',
                profile: {},
              });

              this.sessionCheckDone = true;
            })
            .catch((/* error */) => {
              console.log('JWT令牌過期了，刪除JWT/Session 出包!');
            });
        }
      } else {
        // 如果localStroge沒有jwt token則產生jwt
        console.log('沒有JWT令牌，產生新的JWT');
        this.createJwtUserToken(sessionResponse.type, sessionResponse);
      }
    },

    // 使用者登入(驗證 3)
    // userSwitchToLogined(hashcode) {
    //   const decodeJwtHashCode = new Promise((resolve) => {
    //     console.log('aaaaaaaaaaaaaaaaaaaa', jwtToken);
    //     // const decoded = jwt_decode(this.authJwtToken);
    //     const decoded = jwt_decode(jwtToken);
    //     return resolve(decoded.hashcode);
    //   });

    //   decodeJwtHashCode.then((value) => {
    //     postUserAutoLogin('', {})
    //       .then((res) => {
    //         const userData = res.data;
    //         if (res.data.thumbSrc === null) {
    //           userData.thumbSrc = '';
    //         }
    //         this.changeUserSubscribe(userData.subscribe);
    //         this.processAfterLogined(userData, value);
    //       })
    //       .catch((err) => {
    //         console.log('err', err);
    //       });
    //   });
    // },

    userSwitchToLogined(hashcode) {
      postUserAutoLogin('', {})
        .then((res) => {
          const userData = res.data;
          if (res.data.thumbSrc === null) {
            userData.thumbSrc = '';
          }
          this.changeUserSubscribe(userData.subscribe);
          this.processAfterLogined(userData, hashcode);
        })
        .catch((err) => {
          console.log('err', err);
        });
    },

    processAfterLogined(userData, hashcode) {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });

      this.userLoginMember({
        isLogin: true,
        djangoId: this.djangoId,
        hashCode: hashcode,
        profile: userData,
      });

      console.log('userData', userData);

      this.sessionCheckDone = true;
      this.changeUpdateKey();
      this.initRoomWebsocket();

      // if (userData.read_news === 'no') {
      //   this.changePopShowTutorialStatus({
      //     active: true,
      //     include: 'readNews'
      //   });
      // }

      // 如果個人資料標籤為空，跳轉至標籤選擇頁
      // if (!userData.interest) {
      //   this.$router.push({
      //     name: 'select-tags',
      //     params: {
      //       type: userData.user_type,
      //       username: userData.email,
      //       hashcode,
      //     },
      //   }).catch(() => true);
      // }
      //  else if (userData.interest && this.$route.path !== '/') {
      //   this.$router.push({ name: 'index'}).catch(() => true);
      // }
    },

    // handleBodyOverflowHidden(isActive) {
    //   if (isActive) {
    //     document.body.style.overflow = 'hidden'; return;
    //   }
    //   document.body.style.overflow = 'auto';
    // },

    initUserLoginLatestNews() {
      putUserLoadNews('', {})
        .then((res) => {
          if (res.data.count) {
            const newsList = res.data.results;
            setTimeout(() => {
              this.changePopLatestNewsStatus({
                active: true,
                list: newsList,
              });
            }, 600);
          } else if (!this.loginProfile.email) {
            setTimeout(() => {
              this.changePopBoxStatus({
                active: true,
                include: 'setEmail',
              });
            }, 600);
          }
        })
        .catch((err) => {
          console.log('error', err);
        });
    },

    closeWebSocket() {
      if (this.wsRoom) {
        this.wsRoom.close();
        this.wsRoom = null;
      }
    },

    initRoomWebsocket() {
      this.createWebSocketConnection();
    },

    createWebSocketConnection() {
      if (this.wsRoom && this.wsRoom.readyState !== WebSocket.CLOSED) {
        console.log('WebSocket 連線已存在 Main: ', this.wsRoom);
        return;
      }

      if (process.env.NODE_ENV === 'production') {
        this.wsRoom = new WebSocket(`${this.WS_HEAD}://${window.location.host}/ws/0-${this.loginHashCode}-${this.loginDjangoId}/`);
      } else {
        this.wsRoom = new WebSocket(`${document.location.protocol === 'https:' ? 'ws' : 'ws'}:${process.env.VUE_APP_BACKEND}/ws/0-${this.loginHashCode}-${this.loginDjangoId}/`);
      }

      this.updateExclusiveWebSocket({
        ws: this.wsRoom,
        room: `0-${this.loginHashCode}-${this.loginDjangoId}`,
      });

      this.wsRoom.onopen = this.wsonopen;
      this.wsRoom.onmessage = this.wsonmessage;
      this.wsRoom.onerror = this.wsonerror;
      this.wsRoom.onclose = this.wsclose;
      // console.log('WebSocket Board', this.wsRoom, this.wsRoom.readyState);
      window.addEventListener('beforeunload', () => {
        if (this.wsRoom) {
          this.closeWebSocket();
        }
      });
    },

    wsonopen() {
      this.errorDetect = false;
      this.reconnectAttempts = 0; // 重置重新連線嘗試次數
      console.log('WebSocket 連線成功!');
      // console.log('WS Board 連線成功!', this.wsRoom.readyState);
    },

    wsonerror() {
      // this.wsReadState = 3;
      this.errorDetect = true;
      // console.error('WS 連線失敗!', e);
    },

    wsclose() {
      this.errorDetect = true;
      console.log('WebSocket 關閉連線');
      if (this.loginStatus) {
        this.attemptReconnect();
      }
    },

    wsonmessage(e) {
      if (this.errorDetect) {
        this.wsRoom = null;
        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
        return;
      }
      const _data = JSON.parse(e.data);
      console.log('wsonmessage', _data);

      this.changePopProgressStatus({
        active: false,
        feature: '',
      });

      if (_data.drcell === 'drcell_error') {
        this.changePopBoxStatus({
          active: true,
          include: 'warnDrcellError',
        });
        GlobalEmitter.emit('drcell-error-callback');
      } else if (_data.drcell === 'unrecognized_error') {
        this.changePopBoxStatus({
          active: true,
          include: 'warnUnrecognized',
        });
      } else if (_data.drcell === 'unrecognized_alert') {
        this.changePopBoxStatus({
          active: true,
          include: 'warnUnrecognizedAlert',
        });
      } else if (_data.drcell === 'chat' || _data.drcell === 'chat_consultation' || _data.drcell === 'chat_wizard') {
        if ([
          'text',
          'ai-text',
          'ai-text-chat-youtube',
          'ai-text-chat-analysis',
          'ai-text-chat-diet',
          'ai-text-chat-joke',
          'ai-text-chat-wisdom',
          'ai-text-chat-question',
          'ai-text-chat-trail',
          'ai-text-chat-glucose-pressure',
          'ai-text-chat-glucose-pressure-empty',
          'img',
        ].includes(_data.category)) {
          GlobalEmitter.emit('websocket-message', _data);
        }
      } else if (_data.drcell === 'translate' || _data.drcell === 'photo_translate') {
        this.changePopTranslatorStatus({
          active: true,
          detail: {
            index: null,
            feature: 'create',
            id: _data.create_id,
            language: _data.language,
            date: _data.create_date,
            short: _data.short || null,
            completion: _data.message,
            origin: _data.origin,
          },
        });
      } else if (_data.drcell === 'diet_recognize') {
        const detail = {
          id: _data.create_id,
          name: _data.name,
          photo: _data.photo,
          ingredient: _data.ingredient,
          nutritious: _data.nutritious,
          completion: _data.completion,
          recommend: _data.recommend,
          score: _data.score,
          date: _data.create_date,
        };
        this.changePopDietRecognizeStatus({
          active: true,
          detail,
        });
        GlobalEmitter.emit('diet-recognize-callback', detail);
      } else if (_data.drcell === 'analysis') {
        // const msg = _data.message;
        const detail = {
          id: _data.message.id,
          evalaute: '',
          start_date: _data.message.start_date,
          end_date: '',
          category: _data.message.category,
          broadcast: _data.message.broadcast,
          reminder: _data.message.reminder,
          prediction: _data.message.prediction,
          suggestion: _data.message.suggestion,
          summary: _data.message.summary,
          course: _data.message.course,
          vertex_source: _data.message.vertex_source,
          grade: Number(_data.message.grade),
          // tag: _data.message.tag,
        };
        this.changePopAnalysisStatus({
          active: true,
          detail,
        });
        GlobalEmitter.emit('epro-analysis-callback', detail);
      } else if (_data.drcell === 'chronic_blood') {
        const detail = {
          date: _data.date,
          glucose: _data.glucose,
          pressure: _data.pressure,
        };
        this.changePopChronicBloodDetail({
          active: true,
          detail,
        });
        GlobalEmitter.emit('create-blood-result', detail);
      }
    },

    attemptReconnect() {
      if (this.loginStatus && this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts += 1;
        console.log(`嘗試重新連線 (次數: ${this.reconnectAttempts})...`);

        setTimeout(() => {
          this.createWebSocketConnection();
        }, this.reconnectInterval);
      } else {
        console.error(`已達到最大重新連線次數 (${this.maxReconnectAttempts})，停止嘗試。`);
        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // popActive: 'global/exportPopActive',
      rwdType: 'global/exportRwdType',
      popBoxStatus: 'global/exportPopBoxStatus',
      popProgressStatus: 'global/exportPopProgressStatus',
      popBloodUploadStatus: 'global/exportPopBloodUploadStatus',
      popDrugStatus: 'global/exportPopDrugStatus',
      // popShopStuffStatus: 'global/exportPopShopStuffStatus',
      popYoutubeStatus: 'global/exportPopYoutubeStatus',
      popCourseStatus: 'global/exportPopCourseStatus',
      popZoomStatus: 'global/exportPopZoomStatus',
      // popDeleteResumeStatus: 'global/exportPopDeleteResumeStatus',
      // popDeleteBookmarkStatus: 'global/exportPopDeleteBookmarkStatus',
      popQRcodeStatus: 'global/exportPopQRcodeStatus',
      popTeamFeatureStatus: 'global/exportPopTeamFeatureStatus',
      popHelpFilterStatus: 'global/exportPopHelpFilterStatus',
      popFreeTrailStatus: 'global/exportPopFreeTrailStatus',
      popAgreeListStatus: 'global/exportPopAgreeListStatus',
      popChatAdditionalStatus: 'global/exportPopChatAdditionalStatus',
      popQuestionStatus: 'global/exportPopQuestionStatus',
      popReportStatus: 'global/exportPopReportStatus',
      // popBlessStatus: 'global/exportPopBlessStatus',
      // popDeleteBlessStatus: 'global/exportPopDeleteBlessStatus',
      // popDeleteReplyStatus: 'global/exportPopDeleteReplyStatus',
      // popDeleteAskStatus: 'global/exportPopDeleteAskStatus',
      // popAdviseStatus: 'global/exportPopRecordAdviseStatus',
      popDeleteTranslationStatus: 'global/exportPopDeleteTranslationStatus',
      popDeleteEproStatus: 'global/exportPopDeleteEproStatus',
      popShowTutorial: 'global/exportPopShowTutorialStatus',
      popTranslatorStatus: 'global/exportPopTranslatorStatus',
      popAnalysisStatus: 'global/exportPopAnalysisStatus',
      popDietRecognizeStatus: 'global/exportPopDietRecognizeStatus',
      popLatestNewsStatus: 'global/exportPopLatestNewsStatus',
      popVendorProfile: 'global/exportPopVendorProfileStatus',
      popEproRecordDetail: 'global/exportPopEproRecordDetail',
      popChronicBloodDetail: 'global/exportPopChronicBloodDetail',
      popStartupStatus: 'global/exportPopStartupStatus',
      popCheckListStatus: 'global/exportPopCheckListBox',
      popBusinessRequest: 'global/exportPopBusinessRequest',

      forceUpdateKey: 'global/exportForceUpdateKey',
      authJwtToken: 'user/exportUserJwtToken',
      topBarSearchBarStatus: 'user/exportTopBarSearchBarMobileActive',
      topBarNotifyStatus: 'user/exportTopBarNotifyActive',
      topBarFeatureStatus: 'user/exportTopBarFeatureActive',
      topBarHamburgerStatus: 'user/exportHamburgerActive',
      topBarPanelStatus: 'user/exportTopBarPanelActive',

      loginStatus: 'user/exportLoginStatus',
      loginDjangoId: 'user/exportUserDjangoId',
      loginProfile: 'user/exportUserProfile',
      loginHashCode: 'user/exportUserHashCode',

      overviewMode: 'flow/exportIndexOverviewMode',
    }),

    routerPathChange() {
      console.log('routerPathChange', this.$route);

      let returnPath = `${this.$route.path}-${this.forceUpdateKey}`;

      if (!this.$route.name || this.$route.name === null) {
        return returnPath;
      }
      if (this.$route.name.match(/effect/g)) {
        returnPath = 'side-effect';
      } else if (this.$route.name === 'line-authorize') {
        returnPath = 'line-authorize';
      }

      return returnPath;
    },

    hasActivePopBox() {
      const popBoxStates = [
        this.popBoxStatus,
        this.popProgressStatus,
        this.popBloodUploadStatus,
        this.popYoutubeStatus,
        this.popCourseStatus,
        this.popZoomStatus,
        this.popQRcodeStatus,
        this.popDrugStatus,
        this.popAgreeListStatus,
        this.popChatAdditionalStatus,
        this.popQuestionStatus,
        this.popDeleteTranslationStatus,
        this.popDeleteEproStatus,
        this.popReportStatus,
        this.popTeamFeatureStatus,
        this.popHelpFilterStatus,
        this.popShowTutorial,
        this.popFreeTrailStatus,
        this.popTranslatorStatus,
        this.popAnalysisStatus,
        this.popDietRecognizeStatus,
        this.popLatestNewsStatus,
        this.popVendorProfile,
        this.popEproRecordDetail,
        this.popChronicBloodDetail,
        this.popStartupStatus,
        this.popCheckListStatus,
        this.popBusinessRequest,
      ];
      return popBoxStates.some(state => state.active);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    loginStatus() {
      if (this.loginStatus) {
        const loginStatusChange = new Promise((resolve) => {
          this.changeUpdateKey();
          this.initRoomWebsocket();
          // this.$OneSignal.setExternalUserId(`${this.loginDjangoId}`);
          // this.$OneSignal.sendTag('type', this.loginProfile.user_type);
          // this.$OneSignal.sendTags({
          //   type: this.loginProfile.user_type,
          //   aid: `${this.loginDjangoId}`,
          // });

          this.changePopBoxStatus({
            active: false,
            include: '',
          });
          return resolve(this.loginStatus);
        });

        loginStatusChange.then((res) => {
          if (!res) { return; }

          if (this.loginProfile.user_type === 'normal') {
            this.initUserLoginLatestNews();

            if (this.$route.name === 'effect-setup') {
              this.$router.replace('/sideeffect/record');
            }
            // if (!this.loginProfile.vip_trail) {
            //   setTimeout(() => {
            //     this.changePopFreeTrailStatus({
            //       active: true,
            //     });
            //   }, 600);
            // } else {
            //   this.initUserLoginLatestNews();
            // }
          }
          console.log('loginStatusChange', res);
        });
      } else {
        this.closeWebSocket();
      }
    },

    // popBoxStatus() {
    //   this.handleBodyOverflowHidden(this.popBoxStatus.active);
    // },

    // popYoutubeStatus() {
    //   this.handleBodyOverflowHidden(this.popYoutubeStatus.active);
    // },

    $route(to) {
      // 重置基本狀態
      this.setFlowBarFixed(false);
      this.detectUserAgentDevice();
      this.showShortCutBar = true;
      this.showEducationBar = false;
      this.specialBgColor = '';

      // 處理特殊路由邏輯
      const routeName = to.name || '';
      const routePath = to.path || '';
      const hasQueryV = Boolean(to.query?.v);
      const hasQueryF = Boolean(to.query?.f);

      // 處理 effect 和 chronic 相關路由
      if (routeName.match(/effect|chronic/g)) {
        this.specialBgColor = 'isEproMode';
        if (routeName.match(/effect-consult/g) && hasQueryV) {
          this.showShortCutBar = false;
        }
        if (routeName.match(/effect-post/g)) {
          this.showShortCutBar = false;
          this.specialBgColor = 'isGradient';
        }
      } else if (routeName.match(/shop|redeem/g)) {
        this.specialBgColor = 'isShopMode';
      } else if (routePath.match(/course|aidoctor|events/g)) {
        this.showEducationBar = true;
      } else if (routeName.match(/help/g) && hasQueryF) {
        this.showShortCutBar = false;
      } else if (routeName.match(/index/g) && hasQueryV) {
        this.showShortCutBar = false;
      }
    },
  },
};

</script>

<style lang="scss">
  @import '../sass/base.scss';
</style>
